export default __webpack_public_path__ + "static/media/FRCLib.de546c30.svg";